import { ability, updateAbility } from 'utils/permissions';
import {
  GET_USER_PENDING,
  GET_USER_FAIL,
  GET_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  GET_USERS_PENDING,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  UPDATE_USER,
} from '../actions/userActions';

const initialState = {
  user: {
    loading: true,
    loaded: false,
    isAuthenticated: false,
  },
  users: {
    loading: false,
    loaded: true,
    results: [],
  },
};


export const userReducer = (state = initialState.user, action) => {
  switch (action.type) {
    case GET_USER_PENDING:
      return {
        loading: true,
        loaded: false,
        isAuthenticated: false,
      };
    case GET_USER_SUCCESS:
      updateAbility(ability, action.payload);
      return {
        loading: false,
        loaded: true,
        isAuthenticated: true,
        ...action.payload,
      };
    case UPDATE_USER.success:
      return {
        loading: false,
        loaded: true,
        isAuthenticated: true,
        ...action.payload.data,
      };
    case GET_USER_FAIL:
      return {
        loading: false,
        loaded: true,
        isAuthenticated: false,
        ...action.payload,
      };
    case LOGOUT_USER_SUCCESS:
      return {
        loading: false,
        loaded: true,
        isAuthenticated: false,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const usersReducer = (state = initialState.users, action) => {
  switch (action.type) {
    case GET_USERS_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case GET_USERS_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_USERS_SUCCESS: {
      return {
        loading: false,
        loaded: true,
        results: action.payload,
      };
    }
    default:
      return state;
  }
};
